if (!import.meta.env.VITE_API_URL) {
  throw new Error('VITE_API_URL is not defined in environment variables')
}

if (!import.meta.env.VITE_WS_URL) {
  throw new Error('VITE_WS_URL is not defined in environment variables')
}

if (!import.meta.env.VITE_EMAILJS_SERVICE_ID) {
  throw new Error(
    'VITE_EMAILJS_SERVICE_ID is not defined in environment variables'
  )
}

if (!import.meta.env.VITE_EMAILJS_TEMPLATE_ID) {
  throw new Error(
    'VITE_EMAILJS_TEMPLATE_ID is not defined in environment variables'
  )
}

if (!import.meta.env.VITE_EMAILJS_PUBLIC_KEY) {
  throw new Error(
    'VITE_EMAILJS_PUBLIC_KEY is not defined in environment variables'
  )
}

export const apiUrl = import.meta.env.VITE_API_URL
export const webSocketURL = import.meta.env.VITE_WS_URL
export const emailjsServiceId = import.meta.env.VITE_EMAILJS_SERVICE_ID
export const emailjsTemplateId = import.meta.env.VITE_EMAILJS_TEMPLATE_ID
export const emailjsPublicKey = import.meta.env.VITE_EMAILJS_PUBLIC_KEY